import React, { useEffect, useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import apis from "services";
import { DataGrid } from "@mui/x-data-grid";
import BlogsTable from "components/datagrid/BlogsTable";
import { toast } from "react-toastify";
import Link from "hooks/Link";
import Toolbar from "../../components/@material-extend/CustomToolbar";
import ImagePreview from "../../components/modals/ImagePreview";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import useNavigate from "hooks/Navigate";
import { useSelector } from "react-redux";
const Blogs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { adminUser } = useSelector((store) => store.admin);
  const [image, setImage] = useState("");
  const [blog, setBlogs] = useState([]);
  const [imageModal, setImageModal] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [loading, setLoading] = useState(false);

  const closeImageModal = (image) => {
    if (image) setImage(image);
    setImageModal((prevState) => !prevState);
  };

  const fetchAllBlogs = async () => {
    setLoading(true);
    try {
      const res = await apis.getAllActiveBlog();
      setBlogs(res?.data?.blog);
    } finally {
      setLoading(false);
    }
  };

  const handleDisableBlog = async (id) => {
    const res = await apis.disableBlog(id);
    if (res.data.status) {
      toast.success(res.data.message);
      await fetchAllBlogs();
    }
  };
  const handleEnableBlog = async (id) => {
    const res = await apis.enableBlog(id);
    if (res.data.status) {
      toast.success(res.data.message);
      await fetchAllBlogs();
    }
  };
  const handleDeleteBlog = async (id) => {
    const formattedId = typeof id === "string" ? [id] : id;
    const res = await apis.deleteBlogs(formattedId);
    if (res?.data?.status) {
      toast.success(res.data?.message);
      setSelectionModel([]);
      await fetchAllBlogs();
    } else toast.error(res.data?.message);
  };

  useEffect(() => {
    (async () => {
      await fetchAllBlogs();
    })();
  }, []);

  const methods = {
    handleEnableBlog,
    handleDisableBlog,
    navigate,
    handleDeleteBlog,
  };
  const { rows, columns } = BlogsTable(blog, methods, closeImageModal);

  const DeleteBlogButton = ({ rows }) => {
    const ids = rows.length === 0 ? [] : [...rows.map((record) => record._id)];

    return (
      // <button className='btn danger-btn' onClick={() => handleDeleteStore(ids)}>Delete Stores</button>
      <></>
    );
  };

  const AddBlogButton = () => {
    return <></>;
  };

  const NewToolbar = () => (
    <Toolbar buttons={[<AddBlogButton />, <DeleteBlogButton />]} />
  );

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container
                maxWidth="lg"
                sx={{ mt: 4, mb: 4 }}
                className="mainContainerComp"
              >
                <div className="flex-with-title">
                  {/* <h3 className="dashboard-title">{t("titles.blog")}</h3> */}

                  <Link
                    to={
                      adminUser?.type === "owner"
                        ? "/admin/blog/add"
                        : "/sub-admin/blog/add"
                    }
                    className="lp-btn d-flex align-items-center annualProgressBtn"
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_117_2109)">
                        <path
                          d="M5.20236 0.00194835C4.90239 0.023521 4.72185 0.173122 4.57892 0.388379C3.10732 2.61177 1.63572 4.83468 0.160356 7.05478C-0.0173648 7.3221 -0.0488656 7.58988 0.0733761 7.8858C0.40578 8.69196 0.734422 9.49953 1.05977 10.309C1.10256 10.4159 1.15286 10.4581 1.27511 10.4581C4.38992 10.4539 7.50426 10.4539 10.6191 10.4581C10.7498 10.4581 10.7996 10.4098 10.8448 10.2982C11.1588 9.51641 11.4724 8.7337 11.802 7.95849C11.9468 7.61849 11.9181 7.32444 11.7122 7.01633C10.6666 5.45278 9.63127 3.88267 8.59221 2.31491C8.16155 1.66538 7.73088 1.01586 7.30115 0.365869C7.16151 0.154833 6.97815 0.0207071 6.71204 0.00335526C6.7064 0.0483764 6.69982 0.0769835 6.69982 0.105591C6.69935 1.96365 6.70076 3.82218 6.69559 5.68023C6.69559 5.79607 6.75812 5.82749 6.83663 5.87157C7.43374 6.20923 7.76426 6.7251 7.80752 7.40557C7.86535 8.32147 7.21887 9.14967 6.3345 9.32601C5.41816 9.50844 4.52203 9.01273 4.20327 8.14655C3.88638 7.28505 4.24135 6.32601 5.05049 5.88236C5.16239 5.82093 5.20612 5.75996 5.20565 5.62912C5.20048 3.81796 5.20236 2.00633 5.20236 0.195164C5.20236 0.137481 5.20236 0.0797973 5.20236 0.00194835ZM1.48762 11.9668C1.48762 12.0395 1.48762 12.0911 1.48762 12.1426C1.48762 12.8161 1.48668 13.49 1.48762 14.1634C1.48903 14.7009 1.78805 14.9987 2.3278 14.9991C4.74254 15.0001 7.15728 15.0001 9.5725 14.9991C10.1118 14.9991 10.4113 14.7004 10.4122 14.1634C10.4136 13.49 10.4122 12.8161 10.4122 12.1426V11.9668H1.48762ZM13.5049 2.99679C13.7682 2.99679 14.0132 3.00101 14.2576 2.99585C14.6968 2.98647 15.016 2.64412 14.9991 2.20751C14.9836 1.8042 14.6657 1.50547 14.2327 1.49468C13.9948 1.48905 13.7569 1.49374 13.5059 1.49374C13.5059 1.24003 13.5096 1.01211 13.5049 0.784659C13.496 0.317096 13.1786 -0.00555517 12.7386 7.24712e-05C12.3102 0.00570011 12.0042 0.334917 12.0018 0.794507C12.0004 1.02149 12.0018 1.24847 12.0018 1.49374C11.7573 1.49374 11.5302 1.4914 11.3032 1.49421C10.8386 1.49984 10.4987 1.81968 10.4987 2.24691C10.4987 2.67742 10.8382 2.99444 11.3032 2.99679C11.5302 2.9982 11.7573 2.99679 12.0018 2.99679C12.0018 3.19282 12.0004 3.3729 12.0023 3.55299C12.0037 3.66413 11.9966 3.77762 12.0169 3.88549C12.0855 4.25363 12.4278 4.52094 12.7865 4.49749C13.1899 4.47123 13.4871 4.1664 13.5035 3.74808C13.5129 3.50421 13.5054 3.25941 13.5054 2.99632L13.5049 2.99679ZM6.30488 7.49655C6.30394 7.29443 6.1502 7.14295 5.94709 7.14389C5.74539 7.14483 5.59259 7.29959 5.59353 7.50124C5.59494 7.70196 5.75009 7.85532 5.95179 7.85391C6.15396 7.8525 6.30582 7.69915 6.30441 7.49609L6.30488 7.49655Z"
                          fill="white"
                        />
                        <path
                          d="M5.20236 0.00195312C5.20236 0.0798021 5.20236 0.137485 5.20236 0.195169C5.20236 2.00633 5.20095 3.81796 5.20565 5.62912C5.20565 5.75996 5.16239 5.82093 5.05049 5.88237C4.24135 6.32601 3.88638 7.28505 4.20327 8.14655C4.52203 9.01274 5.41769 9.50844 6.3345 9.32601C7.21887 9.14968 7.86581 8.32148 7.80751 7.40558C7.76426 6.7251 7.43374 6.20924 6.83663 5.87158C6.75812 5.8275 6.69559 5.79561 6.69559 5.68024C6.70029 3.82218 6.69888 1.96365 6.69982 0.105595C6.69982 0.0769883 6.7064 0.0483811 6.71204 0.00336003C6.97815 0.0211809 7.16151 0.154837 7.30115 0.365874C7.73088 1.01587 8.16202 1.66492 8.59221 2.31491C9.63127 3.88268 10.6666 5.45279 11.7122 7.01633C11.9181 7.32445 11.9463 7.61849 11.802 7.95849C11.4724 8.73417 11.1588 9.51641 10.8448 10.2982C10.7996 10.4098 10.7498 10.4586 10.6191 10.4581C7.50426 10.4539 4.38992 10.4539 1.27511 10.4581C1.15286 10.4581 1.10256 10.4159 1.05977 10.309C0.734892 9.5 0.40578 8.69196 0.0733761 7.8858C-0.0488656 7.58988 -0.0173648 7.3221 0.160356 7.05479C1.63572 4.83469 3.10732 2.61177 4.57892 0.388853C4.72185 0.173127 4.90239 0.0239947 5.20236 0.00242209V0.00195312Z"
                          fill="white"
                        />
                        <path
                          d="M1.48844 11.9668H10.4135V12.1427C10.4135 12.8161 10.4144 13.49 10.4135 14.1635C10.4126 14.7004 10.1131 14.9992 9.57379 14.9992C7.15904 15.0001 4.7443 15.0001 2.32909 14.9992C1.78934 14.9992 1.49032 14.7009 1.48891 14.1635C1.4875 13.49 1.48891 12.8161 1.48891 12.1427C1.48891 12.0911 1.48891 12.039 1.48891 11.9668H1.48844Z"
                          fill="white"
                        />
                        <path
                          d="M13.5067 2.99633C13.5067 3.25943 13.5147 3.50423 13.5048 3.74809C13.4883 4.16641 13.1912 4.47124 12.7878 4.49751C12.4295 4.52095 12.0873 4.25364 12.0181 3.8855C11.9979 3.77764 12.005 3.66415 12.0036 3.553C12.0017 3.37292 12.0031 3.19283 12.0031 2.9968C11.7586 2.9968 11.5315 2.99774 11.3044 2.9968C10.8395 2.99399 10.5005 2.67743 10.5 2.24692C10.5 1.81969 10.8399 1.49985 11.3044 1.49422C11.5315 1.49141 11.7586 1.49375 12.0031 1.49375C12.0031 1.24848 12.0022 1.0215 12.0031 0.79452C12.0055 0.334929 12.3115 0.00571246 12.7398 8.4822e-05C13.1799 -0.00601179 13.4973 0.317108 13.5062 0.78514C13.5104 1.01259 13.5071 1.24004 13.5071 1.49422C13.7582 1.49422 13.9961 1.48953 14.234 1.49516C14.667 1.50595 14.9849 1.80421 15.0004 2.20799C15.0173 2.64461 14.6976 2.98695 14.2589 2.99633C14.0144 3.00149 13.7695 2.99727 13.5062 2.99727L13.5067 2.99633Z"
                          fill="white"
                        />
                        <path
                          d="M6.30464 7.49673C6.30558 7.69933 6.15419 7.85315 5.95202 7.85456C5.75032 7.85596 5.5947 7.70261 5.59376 7.50189C5.59235 7.30023 5.74562 7.14547 5.94732 7.14454C6.15043 7.1436 6.30417 7.29461 6.30511 7.4972L6.30464 7.49673Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_117_2109">
                          <rect width="15" height="15" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    {t("buttons.add_blog")}
                  </Link>
                </div>
                <Grid
                  item
                  container
                  justifyContent="flex-end"
                  className="mt-4"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    checkboxSelection
                    rows={rows}
                    columns={columns}
                    onSelectionModelChange={(newSelectionModel) =>
                      setSelectionModel(newSelectionModel)
                    }
                    selectionModel={selectionModel}
                    components={{ Toolbar: NewToolbar }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                    className="card-bg-img"
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
      <ImagePreview status={imageModal} close={closeImageModal} image={image} />
    </>
  );
};

export default Blogs;
